import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className=" bg-bgBlue text-white py-6 mt-6">
      <div className=" max-w-6xl mx-auto">
        <div className="flex max-md:flex-col gap-20 max-md:gap-4 justify-between max-md:items-start items-center pb-6 max-md:pt-6 mx-auto w-11/12">
          <h2 className=" text-xl text-nowrap">کلینیک لانجویتی دکتر شکیبی</h2>
          <ul className=" flex text-gray-300 items-center font-bold max-md:flex-col  max-md:items-start  transition-all duration-300 ">
            <li className=" block">
              <a
                href=""
                className=" hover:text-white    pl-4 py-2 relative block"
                onClick={() => navigate("/")}
              >
                خانه
              </a>
            </li>

            <li>
              <a
                href=""
                className=" hover:text-white    py-4 relative block"
                onClick={() => navigate("/contact-us")}
              >
                تماس با ما
              </a>
            </li>
          </ul>
        </div>
        <div className=" h-px bg-slate-300 w-11/12 mx-auto "></div>

        <p className="  text-right py-6 mx-auto w-11/12">
          &copy; تمامی حقوق محفوظ است.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
